export function legacyWarn(component: string) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(
      `@vimeo/bifrost: Legacy ${component} is no longer supported and should be upgraded to its equivalent in the current verison of @vimeo/iris as soon as possible!`,
    );
  }
}
